export default __webpack_public_path__ + "static/media/hero-grid-figma.c1674c98.png";